import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CompanyTable from "./CompanyTable"; // Updated to CompanyTable
import { getCompanies } from "../../store/AsyncMethods/CompanyMethod"; // Updated to CompanyMethod
import { useTranslation } from "react-i18next";

export default function ManageCompanyMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { user } = useSelector((state) => state.AuthReducer);

  

  useEffect(() => {
    if (user) { 
      dispatch(getCompanies());
    }
  }, [user, dispatch]);

  return (
    <div className="">
      <div className="flex justify-end">
        <Button
          label={t("add_company")}
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() => navigate("/add-company")}
        />
      </div>

      <div className="my-4">
        <CompanyTable /> 
      </div>
    </div>
  );
} 